<template lang="html">
  <!-- <img src="@/assets/logo.png" alt="Diensten Centrum" width="200" /> -->
  <h1 class="title text-primary text-start pb-5">Wie speelt er?</h1>
  <input
    v-model="firstName"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Voornaam"
    required
  />
  <input
    v-model="lastName"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Achternaam"
    required
  />
  <input
    v-model="email"
    class="form-control field no-focusborder"
    type="email"
    ref="inputfield"
    placeholder="E-mail"
    required
  />
  <div class="validation-message">{{ validateEmail }}</div>
  <input
    v-model="phone"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Telefoon"
    required
  />

  <div class="question-field">
    <label class="question-label">
      Heb je interesse om bij Scania te werken?
    </label>
    <div class="radio-group">
      <div class="radio-option">
        <input
          type="radio"
          id="scania-yes"
          :value="true"
          v-model="wilBijScaniaWerken"
          class="radio-input"
        />
        <label for="scania-yes" class="radio-label">Ja</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="scania-no"
          :value="false"
          v-model="wilBijScaniaWerken"
          class="radio-input"
        />
        <label for="scania-no" class="radio-label">Nee</label>
      </div>
    </div>
  </div>

  <!-- <input
    v-model="company"
    class="form-control field no-focusborder text-start"
    type="text"
    ref="inputfield"
    placeholder="School / Bedrijf"
    required
  /> -->
  <div class="d-grid gap-2 pt-4">
    <button
      type="button"
      class="btn btn-secondary btn-lg mt-3"
      :disabled="isDisabled == true"
      @click="setPersonalData()"
    >
      Doorgaan
    </button>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    company: null,
    wilBijScaniaWerken: null,
  }),
  computed: {
    isDisabled() {
      if (
        this.firstName &&
        this.lastName &&
        this.email &&
        this.isEmailValid &&
        this.wilBijScaniaWerken !== null
      ) {
        return false;
      }
      return true;
    },
    isEmailValid() {
      if (this.email === null || this.email === "") {
        return false;
      }
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email);
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Voer een geldig e-mailadres in";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      // Don't send data if email is not valid
      if (!this.isEmailValid) {
        return;
      }

      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      this.$store.commit("setPhone", this.phone);
      this.$store.commit("setEmail", this.email);
      this.$store.commit("setCompany", this.company);
      this.$store.commit("question_one", this.wilBijScaniaWerken);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 40px;
  color: #fabb33 !important;
  font-weight: 700;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  outline: none;
  border: none;
  border-radius: 10px;
  width: 100%;
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 10px;
  color: #161743;
  background-color: rgba(255, 255, 255, 0.9);
}
.field::placeholder {
  color: #161743;
  opacity: 0.6;
  text-align: center;
}
.btn {
  border-radius: 10px;
}
.validation-message {
  color: #fabb33;
  font-size: 0.9rem;
  margin-bottom: 10px;
  text-align: left;
}
.question-field {
  margin-bottom: 20px;
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
}
.question-label {
  display: block;
  color: #161743;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
}
.radio-group {
  display: flex;
  justify-content: center;
  gap: 30px;
}
.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
}
.radio-input {
  width: 20px;
  height: 20px;
  accent-color: #fabb33;
}
.radio-label {
  color: #161743;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
}
</style>
